import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import AvatarWithDefault from 'shared/components/Avatar';

import { getCompany, selectIsAfterHours } from '../../app/ChatApp/selectors';

import styles from './styles';

export class ChatHistoryHeaderInfo extends PureComponent {
  renderGreeting = () => {
    const { isAfterHours, offhoursMessage, greeting } = this.props;
    if (isAfterHours) {
      return (
        <div
          role="heading"
          title={offhoursMessage}
          style={styles.companyMessage}
          className="kustomer-app-header-greeting"
          aria-level="2"
        >
          {offhoursMessage}
        </div>
      );
    }
    return (
      <span
        role="heading"
        title={greeting}
        style={styles.companyMessage}
        className="kustomer-app-header-greeting"
        aria-level="3"
      >
        {greeting}
      </span>
    );
  };

  renderWaitMessage = () => {
    const { waitMessage, isAfterHours } = this.props;

    if (isAfterHours) return null;

    return (
      <span
        role="heading"
        title={waitMessage}
        style={styles.waitMessage}
        aria-level="2"
        className="kustomer-app-header-wait-message"
      >
        {waitMessage}
      </span>
    );
  };

  renderAvatar = () => {
    const { avatarUrl, name } = this.props;
    return (
      <div style={styles.avatar}>
        <AvatarWithDefault defaultName={name} avatarUrl={avatarUrl} size={42} showUnread />
      </div>
    );
  };

  renderHeader = () => {
    const { name } = this.props;
    return (
      <div style={styles.headerInfoWrap}>
        {this.renderAvatar()}
        <span style={styles.companyName} role="heading" aria-level="1" className="kustomer-app-header-company-name">
          {name}
        </span>
        {this.renderWaitMessage()}
        {this.renderGreeting()}
      </div>
    );
  };

  render() {
    return this.renderHeader();
  }
}

ChatHistoryHeaderInfo.propTypes = {
  avatarUrl: PropTypes.string,
  name: PropTypes.string,
  greeting: PropTypes.string,
  offhoursMessage: PropTypes.string,
  waitMessage: PropTypes.string,
  isAfterHours: PropTypes.bool,
};

ChatHistoryHeaderInfo.defaultProps = {
  avatarUrl: '',
  name: '',
  greeting: '',
  offhoursMessage: '',
  waitMessage: '',
  isAfterHours: false,
};

const mapStateToProps = state => {
  const company = getCompany(state);
  const waitMessage = company.get('waitMessage');
  const greeting = company.get('greeting');
  const offhoursMessage = company.get('offhoursMessage');
  const name = company.get('name');
  const avatarUrl = company.get('avatarUrl');

  return {
    avatarUrl,
    name,
    isAfterHours: selectIsAfterHours(state),
    greeting,
    offhoursMessage,
    waitMessage,
  };
};

export default connect(mapStateToProps)(ChatHistoryHeaderInfo);
